// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import cx from 'classnames';
import ReactCSSTransitionGroup from '../../ReactCSSTransitionGroupCompat/ReactCSSTransitionGroupCompat';
// Components
import OMInputField from '../../OMComponents/OMInputField/OMInputField';
import CloudflareCaptcha from '../../CloudflareCaptcha/CloudflareCaptcha';
import OMButtonWithPreloader from '../../OMComponents/OMButtonWithPreloader/OMButtonWithPreloader';
import appendLocale from '../../../helpers/appendLocale';
import CAPTCHA_ACTIONS from '../../../helpers/captchaConstants';
// Styles
import * as styles from '../PhoneVerificationForm.scss';

export default class PhoneNumberSection extends Component {
  state = {
    isSubmitButtonShown: true,
    isAgainSentShown: false
  }

  componentWillReceiveProps(newProps) {
    if (!this.props.phoneNumberSent && newProps.phoneNumberSent) {
      if (this.state.isSubmitButtonShown) {
        this.setState({ isSubmitButtonShown: false });
      } else {
        this.setState({ isAgainSentShown: true });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isAgainSentShown && this.state.isAgainSentShown) {
      this.sentTitleTimeout = setTimeout(() => {
        this.setState({ isAgainSentShown: false });
      }, 3000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.sentTitleTimeout);
  }

  errorMessage = () => {
    const { translate, showErrorMessage, errorMessage, locale, phoneNumberAlreadyTaken } = this.props;
    return !!showErrorMessage && (
      <p className={styles.invalidMessage}>
        {errorMessage}
        {phoneNumberAlreadyTaken && (
          <Link to={appendLocale(locale, '/contact')}>
            &nbsp;
            {translate('contactUs')}
          </Link>
        )}
      </p>
    );
  }

  submitButton = () => {
    const { showPhonePreloader, translate, sendPhoneNumber } = this.props;
    return (
      <div key="submitButton" className={styles.submitButton}>
        <OMButtonWithPreloader
          showPreloader={showPhonePreloader}
          onClick={sendPhoneNumber}
          innerText={translate('submitButton')}
        />
        {this.errorMessage()}
      </div>
    );
  }

  notReceiveSmsMessage = () => {
    const { translate, showPhonePreloader, sendPhoneNumber } = this.props;
    const title = this.state.isAgainSentShown
      ? <span className={styles.sentTitle}>{translate('sent')}</span>
      : translate('sendAgain');

    return (
      <div key="notReceiveMessage" className={styles.notReceiveMessage}>
        {translate('notReceiveSms')}
        <button
          disabled={showPhonePreloader}
          onClick={sendPhoneNumber}
          className={styles.sendAgain}
        >
          &nbsp;{showPhonePreloader
            ? <i className={cx('icon icon-om-spinner om-pulse', styles.spinner)} />
            : title}
        </button>
        {this.errorMessage()}
      </div>
    );
  }

  render() {
    const { translate, phoneNumberIsInvalid, validatePhoneNumber, onChange, isMobile, isRtl,
      fetchReCaptchaToken, doResetCaptcha, phoneForCaptcha } = this.props;
    return (
      <div className={styles.phoneSection}>
        <span className={styles.label}>{translate('phoneNumber')}</span>
        <div>
          <OMInputField
            type="tel"
            inputMode="numeric"
            placeholder={`${translate('phonePlaceholder')}`}
            name="phone"
            isInvalid={phoneNumberIsInvalid}
            showHoverTooltip={phoneNumberIsInvalid}
            validate={validatePhoneNumber}
            tooltipMessage={`${translate('incorrectPhoneMessage')}`}
            onChange={onChange}
            isMobile={isMobile}
            maxLength="14"
            isRtl={isRtl}
          />
          <CloudflareCaptcha
            action={CAPTCHA_ACTIONS.SEND_VERIFICATION_SMS}
            cdata={phoneForCaptcha}
            doReset={doResetCaptcha}
            fetchToken={fetchReCaptchaToken}
          />
          <ReactCSSTransitionGroup
            transitionName="code-section"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={400}
          >
            { this.state.isSubmitButtonShown ? this.submitButton() : this.notReceiveSmsMessage() }
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }
}

PhoneNumberSection.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string,
  onChange: PropTypes.func,
  validatePhoneNumber: PropTypes.func,
  sendPhoneNumber: PropTypes.func,
  fetchReCaptchaToken: PropTypes.func,
  phoneForCaptcha: PropTypes.string,
  phoneNumberIsInvalid: PropTypes.bool,
  phoneNumberSent: PropTypes.bool,
  showPhonePreloader: PropTypes.bool,
  isMobile: PropTypes.bool,
  showErrorMessage: PropTypes.bool,
  doResetCaptcha: PropTypes.bool,
  errorMessage: PropTypes.string,
  phoneNumberAlreadyTaken: PropTypes.bool,
  isRtl: PropTypes.bool,
  sendAgain: PropTypes.func
};
